import React from 'react';
import PropTypes from 'prop-types';

// Common Components
import Spinner from '../Spinner/Spinner';

// Component Styles
import './loadingMessage.scss';

/**
 * This component shows an error message and a spinner component.
 * @extends {Component}
 */
function LoadingMessage(props) {
  return (
    <div className='wtfLoadingMessage'>
      <p className='wtfLoadingMessage_text'>{props.text}</p>
      <div className='wtfLoadingMessage_loading'>
        <Spinner />
      </div>
    </div>
  );
}

/**
 * Set the LoadingMessage component props default values.
 * @type {Object}
 */
LoadingMessage.defaultProps = {
  text: '',
};

/**
 * Declare the LoadingMessage component PropTypes for better validation.
 * @type {Object}
 */
LoadingMessage.propTypes = {
  text: PropTypes.string,
};

export default LoadingMessage;



// WEBPACK FOOTER //
// ./src/components/common/LoadingMessage/LoadingMessage.js